import { Outlet, createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { redirectIfAuthenticated } from '@/lib/require-auth'

// Parent layout for /signup and /signup/reseller. Must render <Outlet /> so
// nested routes (reseller self-signup) are not swallowed by the customer form.
const searchSchema = z.object({
  ref: z.string().optional(),
  token: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/signup')({
  validateSearch: searchSchema,
  beforeLoad: async () => {
    await redirectIfAuthenticated({})
  },
  component: Outlet,
})
